var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNotmet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 9,
    viewBox: "0 0 8 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58594 1.71094L4.77344 4.52344L7.5625 7.3125C7.79688 7.52344 7.79688 7.875 7.5625 8.08594C7.35156 8.32031 7 8.32031 6.78906 8.08594L3.97656 5.29688L1.1875 8.08594C0.976562 8.32031 0.625 8.32031 0.414062 8.08594C0.179688 7.875 0.179688 7.52344 0.414062 7.28906L3.20312 4.5L0.414062 1.71094C0.179688 1.5 0.179688 1.14844 0.414062 0.914062C0.625 0.703125 0.976562 0.703125 1.21094 0.914062L4 3.72656L6.78906 0.9375C7 0.703125 7.35156 0.703125 7.58594 0.9375C7.79688 1.14844 7.79688 1.5 7.58594 1.71094Z",
    fill: "#F64E6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotmet);
export default __webpack_public_path__ + "static/media/icon-notmet.e3e838dd68f8bfc9f667ae215c7fc949.svg";
export { ForwardRef as ReactComponent };